<template>
    <div class="timeline-container py-3">
        <div class="title-block">
            <div class="title-block__left">
                <div class="title-block__list">
                    <v-select
                        v-model="plView"
                        :items="[{ id: 1, name: 'Список' }, { id: 2, name: 'Таймлайн' }]"
                        item-title="name"
                        return-object
                        variant="outlined"
                        color="primary"
                        density="compact"
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </div>
            </div>
        </div>
        <div class="pl-container">
            <div class="pl-container__left">

                <!-- Превью видео -->
                <div class="pl-video-preview mb-3" ref="preview" :class="fs ? 'in-fs-mode' : ''">
                    <video ref="media" @canplay="showMediaInfo()" :src="mediaSrc"
                        :poster="mediaPoster" type="video/mp4" @timeupdate="udateCurrentTime">
                    </video>

                    <div class="pl-video-preview__play-big" :class="play ? 'is-hidden' : ''" @click="changePlayState">
                        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="23.5" cy="23.5" r="23.5" fill="rgba(13, 14, 17, 0.77)" fill-opacity=".77" />
                            <g filter="url(#prefix__filter0_d_313_5240)">
                                <path d="M37 23.5L17.5 11.809V35.19L37 23.5z" fill="#fff" />
                            </g>
                            <defs>
                                <filter id="prefix__filter0_d_313_5240" x="13.5" y="11.809" width="27.5" height="31.383"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                        result="hardAlpha" />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_313_5240" />
                                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_313_5240" result="shape" />
                                </filter>
                            </defs>
                        </svg>
                    </div>

                    <div class="pl-video-preview__file" v-show="play">
                        <span ref="filename">---</span>&nbsp;&nbsp;<span ref="fileTl">---</span>
                    </div>

                    <div class="pl-video-preview__controls">
                        <button class="reset-btn pl-control play" :class="play ? '' : 'on-pause'"
                            @click="changePlayState" title="play/pause">
                            <svg class="paused" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 7L-6.52533e-07 13.9282L-4.68497e-08 0.0717965L9 7Z" fill="currentColor" />
                            </svg>
                            <svg class="playing" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0H2V14H0V0Z" fill="currentColor" />
                                <path d="M7 0H9V14H7V0Z" fill="currentColor" />
                            </svg>
                        </button>

                        <button class="reset-btn pl-control play-next" v-show="mediaIndex < medialist.length - 1"
                            @click.prevent="nextMedia" title="play next">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 8L3 2V14L10 8Z" fill="currentColor" />
                                <rect x="12" y="2" width="2" height="12" fill="currentColor" />
                            </svg>
                        </button>

                        <button class="reset-btn pl-control mute" :class="muted ? 'on-mute' : ''"
                            @click.prevent="changeMuteState" title="Mute/Unmute">
                            <svg class="unmuted" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.2007 7C11.2007 6.0293 10.4885 5.19805 9.47773 4.84805L8.93952 5.92539C9.44491 6.10039 9.79934 6.51602 9.79934 7.00273C9.79934 7.48672 9.44491 7.90234 8.93952 8.08008L9.47773 9.15742C10.4885 8.80195 11.2007 7.9707 11.2007 7ZM10.5541 2.69336L10.0159 3.7707C11.5354 4.29844 12.602 5.54531 12.602 7C12.602 8.45742 11.5354 9.70156 10.0159 10.2293L10.5541 11.3066C12.579 10.6039 14 8.94141 14 7C14 5.05859 12.579 3.39609 10.5541 2.69336ZM0 4.08242V9.91484H2.79934L7.69902 14V0L2.79934 4.08242H0Z"
                                    fill="currentColor" />
                            </svg>
                            <svg class="muted" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#prefix__clip0_243_5319)">
                                    <path d="M0 4.082v5.833h2.8L7.698 14V0l-4.9 4.082H0z" fill="currentColor" />
                                    <path d="M9 9l4-4M13 9L9 5" stroke="currentColor" stroke-width="1.5" />
                                </g>
                                <defs>
                                    <clipPath id="prefix__clip0_243_5319">
                                        <path fill="currentColor" d="M0 0h14v14H0z" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>

                        <Slider class="volume" :tooltips="false" :min="0.0" :max="1.0" :step="-1" @slide="changeVolume" v-model="volume" />

                        <div class="state"><span>{{ currentTime }}</span> / <span>{{ mediaFullLength }}</span></div>

                        <button class="reset-btn pl-control fs" @click.prevent="toggleFs"
                            :class="fs ? 'in-fs-mode' : ''" title="Fullscreen">
                            <svg fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#prefix__clip0_241_5312)">
                                    <path d="M11 1v4h4M5 1v4H1m10 10v-4h4M5 15v-4H1" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="prefix__clip0_241_5312">
                                        <path fill="currentColor" d="M0 0h16v16H0z" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
                <!--  -->
                <div class="title-block">
                    <div class="title-block__left">
                        <div class="title-block__title_2">
                        </div>
                    </div>

                    <div class="title-block__right">
                        <div class="title-block__list">
                            <v-select
                                v-model="tlScale"
                                :items="tlScaleOptions"
                                item-title="name"
                                item-value="id"
                                variant="outlined"
                                color="primary"
                                density="compact"
                                @update:menu="$removeFocus"
                                @click:clear="$removeFocus"
                                @click:control="$removeFocus">
                                <template #no-data>
                                    <v-list-item>
                                        <span>Данные не найдены</span>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </div>
                    </div>
                </div>
                <!-- Список -->
                <div class="edit-pl-list-view" v-show="plView.id == 1"
                    @drop.prevent="dropItem($event)"
                    @dragover.prevent @dragenter.prevent>
<!--                    <div class="search-control">-->
<!--                        <input type="text" class="search-control__input form-control" placeholder="Поиск">-->
<!--                        <button class="search-control__input-btn reset-btn">-->
<!--                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none"-->
<!--                                xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path-->
<!--                                    d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z"-->
<!--                                    fill="currentColor"></path>-->
<!--                            </svg>-->
<!--                        </button>-->
<!--                    </div>-->

                    <div class="devices-list">
                        <div v-for="(item, index) in medialist" :key="item.id" class="devices-item" draggable="true"
                            @click="changeMediaByClick(index)" :class="index == mediaIndex ? 'is-active' : ''"
                            @drop.prevent.stop="endSwapItem(item, index)"
                            @drag.prevent.stop="startSwapItem(item, index)" @dragover.prevent @dragenter.prevent>
                            <div class="devices-item__info">
                                <div class="devices-cell devices-cell_d"></div>
                                <div class="devices-cell devices-cell_p">
                                    <img :src="src(item.thumb)" alt="" class="devices-preview">
                                </div>
                                <div class="devices-cell devices-cell_n">
                                    {{ item.name }}
                                </div>
                                <div class="devices-cell devices-cell_t">
                                    {{ secondsToHms(item.length, 'a') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->


                <!-- Таймлайн -->
                <div class="edit-pl-tl-view"
                    v-show="plView.id == 2"
                    @drop.prevent="dropItem($event)"
                    @dragover.prevent
                    @dragenter.prevent>

                    <div class="pl-timeline mb-2" @wheel="changeScale">
                        <button class="reset-btn play" :class="play ? '' : 'on-pause'" @click.prevent="changePlayState"
                            title="play/pause">
                            <svg class="paused" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 7L-6.52533e-07 13.9282L-4.68497e-08 0.0717965L9 7Z" fill="currentColor" />
                            </svg>
                            <svg class="playing" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0H2V14H0V0Z" fill="currentColor" />
                                <path d="M7 0H9V14H7V0Z" fill="currentColor" />
                            </svg>
                        </button>

                        <div class="pl-timeline-wrapper" ref="tlWrap"
                            :style="{ '--tl-point-width': tlPointWidth + 'px' }">
                            <!-- Полоса с секундами -->
                            <div class="pl-scale" ref="tlScale"></div>
                            <!-- Полоса с секундами -->

                            <!-- Таймлайн превью -->
                            <div class="pl-thumbs" @drop.prevent.stop="endSwapItemLast()">
                                <div v-for="(item, index) in medialist" :key="item.id" class="pl-thumb"
                                    draggable="true"
                                    @drop.prevent.stop="endSwapItem(item, index)"
                                    @drag.prevent.stop="startSwapItem(item, index)"
                                    @dragover.prevent
                                    @dragenter.prevent
                                    :style="{ 'background-image': 'url(' + src(item.thumb) + ')', 'width': item.length * 10 + 'px' }"
                                    @click="changeMediaByClick(index)"
                                    :class="index == mediaIndex ? 'is-active' : ''">

                                    <div class="pl-thumb-info">
                                        <div class="filename">{{ item.name }}</div>
                                        <div class="length">{{ '(' + secondsToHms(item.length, 'a') + ')' }}</div>
                                    </div>

                                    <button class="remove reset-btn" title="Удалить"
                                        @click.prevent="removeItem(index)">
                                    </button>
                                </div>
                            </div>
                            <!-- Таймлайн превью -->
                        </div>
                    </div>
                </div>


                <!--  -->
            </div>
            <div class="pl__right box pl-explorer-panel">
<!--                <div class="search-control">-->
<!--                    <input type="text" class="search-control__input form-control" placeholder="Поиск" v-model="explorerSearchValue">-->
<!--                    <button class="search-control__input-btn reset-btn" type="button" v-show="!explorerSearchValue.trim()">-->
<!--                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path-->
<!--                                d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z"-->
<!--                                fill="currentColor"></path>-->
<!--                        </svg>-->
<!--                    </button>-->
<!--                    <button class="search-control__input-btn reset-btn" type="button" v-show="explorerSearchValue.trim()" @click.prevent="explorerSearchValue = ''">-->
<!--                        <svg viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path d="M17.35 5.799l-11.399 11.4M5.951 5.799l11.4 11.4" stroke="currentColor"-->
<!--                                stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" />-->
<!--                        </svg>-->
<!--                    </button>-->
<!--                </div>-->
                <div class="content-list-wrap">
                    <div class="content-breadcrumbs">
                        <div class="content-breadcrumbs__item">
                            <a class="content-breadcrumbs-link">
                                <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.265 3.482h2.533l1.9 1.9h4.433a1.267 1.267 0 011.267 1.267v5.067a1.266 1.266 0 01-1.267 1.266H3.265a1.266 1.266 0 01-1.267-1.266V4.749a1.267 1.267 0 011.267-1.267z"
                                        stroke="currentColor" stroke-width="1.267" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <span>Контент</span>
                            </a>
                        </div>
                    </div>

                    <div class="content-list">
                        <!-- Тут надо заново интегрировать -->
                        <table>
                            <tbody>
                                <nautilus-row-element
                                    v-for="item in contents"
                                    :item="item"
                                    @openDir="openDir"
                                    :deep="0"
                                    @dragItem="dragItem"
                                    @toggleSelect="selectItem"
                                    :hasFiles="hasFiles"
                                    >
                                </nautilus-row-element>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import example from "../data/example";
import NautilusRowElement from "./NautilusRowElement.vue";

export default {
    name: "TimelineElement",
    components: { NautilusRowElement },

    props: {
        contents: Array,
        domain: String,
        playlist_content: {
            type: Array,
            default: []
        },
        itemsFromFolder: {
            type: Array,
            default: []
        },
        opener: {
            type: String,
            default: ''
        }
    },

    emits: [
        "contentDir",
        "syncContent"
    ],

    data: function () {
        return {
            example,
            plView: { id: 2, name: 'Таймлайн' },
            play: false,
            muted: false,
            fs: false,
            volume: 0.63,
            explorerSearchValue: '',

            // Переменная, в которой накапливается общее время всех медиафайлов, проигранных до текущего.
            currentLength: 0,

            tlScaleOptions: [
                {id: 1, name: 'Минута'},
                {id: 2, name: '5 минут'},
                {id: 3, name: '15 минут'},
                {id: 4, name: '30 минут'},
                {id: 5, name: '60 минут'},
            ],
            tlScale: 1,

            // Ширина деления на шкале времени
            tlPointWidth: 10,

            ctrlIsPressed: false,
            medialist: [],
            mediaIndex: 0,
            currentTime: '00:00',
            picPlayTimoutId: null,
            picPlayIntervalId: null,
            picCurrentTime: 0,
            dragged_item: {},
            swap_item_index: false,
            selectedItems: [],
            hasFiles: null,

            
            time: 0,
            remains: 0,
            elementStart: 0,
            elementNext: 0,
            elementPrev: null
        };
    },

    methods: {
        src(path) {
            if (path) {
                const includesHttps = path.includes('https');
                const includesHttp = path.includes('http');

                if (!includesHttps && !includesHttp) {
                    return `${this.domain}/${path}`;
                }

                return path;
            }
            return path;
        },

        async openDir(item) {
            return await this.$emit('contentDir', item);
        },

        // Воспроизвести элемент контента
        playVideoOrPic() {
            // Если видео
            if (this.medialist[this.mediaIndex].source.includes('mp4')) {
                clearTimeout(this.picPlayTimoutId);
                clearInterval(this.picPlayIntervalId);
                
                if (this.picCurrentTime) {
                    this.media.currentTime = this.medialist[this.mediaIndex].length - this.picCurrentTime;
                }
                this.media.play();
            }
                // Если не видео
                this.play = true;

                // Показываем инфу о элементе контента
                this.showMediaInfo();

                // Очищаем таймер заданного времени воспроизведения элемента
                clearTimeout(this.picPlayTimoutId);

                // Определяем время показа элемента
                // Если this.picCurrentTime уже установлен
                // (возможно, изображение было показано частично),
                // то оставшееся время вычисляется как разница
                // между общей длиной изображения (medialist[this.mediaIndex].length)
                // и уже прошедшим временем.
                if (this.picCurrentTime) {
                    this.remains = (1 + (this.medialist[this.mediaIndex].length - this.picCurrentTime) * 1000);
                } else {
                    // Иначе устанавливаем таймер на полную длительность показа фото
                    this.remains = 1 + this.medialist[this.mediaIndex].length * 1000;
                }

                // Создаем таймер до конца показа текущего элемента
                this.picPlayTimoutId = setTimeout(() => {

                    // По истечении таймера сбрасываем picCurrentTime
                    // clearInterval(this.picPlayIntervalId);
                    this.picCurrentTime = 0;

                    // и запускаем следующий элемент контента
                    // если это не последний элемент в списке (medialist).
                    if (this.mediaIndex < this.medialist.length - 1) {
                        this.elementStart += this.medialist[this.mediaIndex].length;
                        this.mediaIndex++;
                        this.elementNext += this.medialist[this.mediaIndex].length;
                        this.elementPrev = this.elementStart - 1;

                        this.$nextTick(() => {
                            this.changePlayState();
                            this.changePlayState();
                        });

                    } else {
                        this.changePlayState();                        
                        this.currentLength = 0;
                        this.currentTime = this.secondsToHms(this.currentLength, 'b');
                        this.mediaIndex = 0;
                        document.querySelector('.pl-scale-scroll').style.left = '0px';
                        this.elementNext = this.medialist[0].length;
                        this.elementStart = 0;
                        this.elementPrev = -1;
                        return;
                    }
                }, this.remains);

                clearInterval(this.picPlayIntervalId);

                // Устанавливаем интервал для обновления текущего времени отображения изображения
                // (this.picCurrentTime++), чтобы каждую секунду увеличивать счётчик.
                this.picPlayIntervalId = setInterval(() => {
                    this.picCurrentTime++;
                    this.updateCurrentTime();
                }, 1000);
        },

        // Приостановить воспроизведение
        pauseVideoOrPic() {
            // Если видео - ставим на паузу
            if (this.medialist[this.mediaIndex].source.includes('mp4')) {
                this.media.pause();
                this.play = false;
                clearTimeout(this.picPlayTimoutId);
                clearInterval(this.picPlayIntervalId);
            } else {
                // Иначе ставим на паузу счетчики показа фото
                this.play = false;
                
                clearTimeout(this.picPlayTimoutId);
                clearInterval(this.picPlayIntervalId);
            }
        },

        // Toggle воспроизведения
        changePlayState: function (e) {
            if (this.mediaIndex < this.medialist.length) {
                !this.play ? this.playVideoOrPic() : this.pauseVideoOrPic();
            } else {
                this.mediaIndex = 0;
                this.currentLength = 0;
            }
        },

        showMediaInfo: function () {
            this.filename.textContent = this.medialist[this.mediaIndex].source.split('/').pop();
            this.fileTl.textContent = `(${this.secondsToHms(Math.floor(this.medialist[this.mediaIndex].length), 'a')})`;
        },

        changeMuteState: function (e) {
            this.media.muted = !this.media.muted;
            this.muted = !this.muted;
        },

        changeVolume: function (value) {
            this.media.volume = value;
            if (!value) {
                this.muted = true;
            } else {
                this.muted = false;
                this.media.muted = false;
            }
        },

        exitHandler: function () {
            if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                this.fs = false;
            } else {
                this.fs = true;
            }
        },

        toggleFs: function () {
            if (this.fs) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                this.fs = false;

            } else {
                if (this.preview.requestFullscreen) {
                    this.preview.requestFullscreen();
                } else if (this.preview.webkitrequestFullscreen) {
                    this.preview.webkitRequestFullscreen();
                } else if (this.preview.mozRequestFullscreen) {
                    this.preview.mozRequestFullScreen();
                }
                this.fs = true;
            }
        },

        // Рассчет ширины элементов таймлайна
        setPointAndThumbsWidth: function () {

            // Записываем ширину деления в переменную
            // Записываем таймлайн контейнера в переменную
            let wrapperWidth = this.tlWrap.clientWidth;

            // В зависимости от значения селекта, перезаписывается стандартная ширина деления на шкале времени
            // Ширина контейнера делится на равные целые части
            switch (this.tlScale) {
                case 1:
                    this.tlPointWidth = Math.floor(wrapperWidth / 7);
                    break;
                case 2:
                    this.tlPointWidth = Math.floor(wrapperWidth / 6);
                    break;
                case 3:
                    this.tlPointWidth = Math.floor(wrapperWidth / 6);
                    break;
                case 4:
                    this.tlPointWidth = Math.floor(wrapperWidth / 6);
                    break;
                case 5:
                    this.tlPointWidth = Math.floor(wrapperWidth / 7);
                    break;
            }

            // Устанавливаем ширину каждого превью в ленте, если есть
            // В зависимости от значения селекта - ширина превьюх разная
            // Считается как ДЛИТЕЛЬНОСТЬ ЭЛЕМЕНТА / 10 * РАССЧИТАННАЯ ШИРИНА ДЕЛЕНИЯ
            if (this.medialist.length) {
                switch (this.tlScale) {
                    case 1:
                        this.medialist.forEach(item => {
                            item.width = (item.length / 10 * this.tlPointWidth);
                        });
                        break;
                    case 2:
                        this.medialist.forEach(item => {
                            item.width = (item.length / 60 * this.tlPointWidth);
                        });
                        break;
                    case 3:
                        this.medialist.forEach(item => {
                            item.width = (item.length / 180 * this.tlPointWidth);
                        });
                        break;
                    case 4:
                        this.medialist.forEach(item => {
                            item.width = (item.length / 360 * this.tlPointWidth);
                        });
                        break;
                    case 5:
                        this.medialist.forEach(item => {
                            item.width = (item.length / 600 * this.tlPointWidth);
                        });
                        break;
                }
            }
        },

        updateCurrentTime() {           
            this.currentLength ++;

            // Привязываем позицию скролла к таймлайну через счетчик currentLength
            let scroll = document.querySelector('.pl-scale-scroll');
            scroll.style.left = `${this.currentLength * 10}px`;

            // Форматирование результата
            this.currentTime = this.secondsToHms(this.currentLength, 'b');
        },

        // Отображение наполнения шкалы времени над таймлайном
        renderTlPoints: function () {
            this.tlScaleEl.innerHTML = '';
            
            // Получаем ширину контейнера
            let wrapperScrollWidth = this.tlWrap.scrollWidth;

            // Получаем количество делений на шкале времени ШИРИНА КОНТЕЙНЕРА / ШИРИНА ЭЛЕМЕНТА КОНТЕНТА
            let plItems = Math.ceil(wrapperScrollWidth / this.tlPointWidth);

            // Создаем скролл на таймлайне
            const scroll = document.createElement('div');
            scroll.classList.add('pl-scale-scroll');
            this.tlScaleEl.append(scroll);

            const timeline = document.querySelector('.pl-scale');
            const scrollElement = document.querySelector('.pl-scale-scroll');

            let isDragging = false;

            // Начальная позиция мыши по оси X
            let startX = 0;
            // Начальная позиция скролла
            let startLeft = 0;
            // Ограничение на перемещение внутри контейнера
            const containerRect = timeline.getBoundingClientRect();

            // Получаем начальные координаты при нажатии мыши
            scrollElement.addEventListener('mousedown', (event => {
                isDragging = true;
                this.stopPLayback();
                startX = event.clientX;
                startLeft = scrollElement.offsetLeft;
            }))

            document.addEventListener('mousemove', (event) => {
                if (isDragging) {
                    // Вычисляем новое смещение по X
                    let newLeft = Math.round((startLeft + (event.clientX - startX - 65)) / 10) * 10;
                    
                    // Ограничиваем диапазон скролла
                    this.currentLength = newLeft / 10;
                    if (this.currentLength > this.medialist.reduce((sum, item) => sum + item.length, 0) || this.currentLength < 0) {
                        return;
                    }

                    // Устанавливаем значение таймера уже проигранных медиафайлов
                    // в зависимости от положения скролла в контейнере
                    this.currentLength = Math.round((startLeft + (event.clientX - startX - 65)) / 10);
                    this.currentTime = this.secondsToHms(this.currentLength, 'b');

                    // Ограничиваем перемещение в пределах контейнера
                    newLeft = Math.max(0, Math.min(newLeft, containerRect.width - scrollElement.offsetWidth));
                    
                    scrollElement.style.left = `${newLeft}px`;
                    
                    if (this.currentLength == this.elementNext && this.mediaIndex < this.medialist.length - 1) {
                        this.mediaIndex++;

                        this.elementStart = this.currentLength;
                        this.elementNext = this.elementStart + this.medialist[this.mediaIndex].length;
                        this.elementPrev = this.elementStart - 1;
                    }

                    if (this.currentLength == this.elementPrev && this.mediaIndex != 0) {                       
                        this.mediaIndex--;
                        
                        if (this.mediaIndex == 0) {
                            this.elementNext = this.medialist[this.mediaIndex].length;
                        }
                        this.elementStart = this.currentLength - this.medialist[this.mediaIndex].length + 1;
                        this.elementNext = this.elementStart + this.medialist[this.mediaIndex].length;
                        this.elementPrev = this.elementStart - 1;
                    }
                }
            })

            document.addEventListener('mouseup', () => {                
                if (this.currentLength >= this.medialist.reduce((sum, item) => sum + item.length, 0)) {
                    this.currentLength = this.medialist.reduce((sum, item) => sum + item.length, 0);
                }

                if (this.currentLength < 0) {
                    this.currentLength = 0;
                }

                this.picCurrentTime = this.currentLength - this.medialist.slice(0, this.mediaIndex).reduce((sum, item) => sum + item.length, 0);               
                isDragging = false;
            });

            // Создаем разметку на таймлайне
            for (let i = 0; i < plItems; i++) {
                const point = document.createElement('div');
                point.classList.add('pl-scale-point');
                switch (this.tlScale) {
                    case 1:
                        point.textContent = `${i * 10} сек`;
                        break;
                    case 2:
                        point.textContent = `${i} мин`;
                        break;
                    case 3:
                        point.textContent = `${i * 3} мин`;
                        break;
                    case 4:
                        point.textContent = `${i * 6} мин`;
                        break;
                    case 5:
                        point.textContent = `${i * 10} мин`;
                        break;
                }
                this.tlScaleEl.append(point);
            }
        },

        removeItem(index) {
            this.medialist.splice(index, 1);
            this.$nextTick(() => {
                this.setPointAndThumbsWidth();
                this.renderTlPoints();
            });
        },

        pressCtrl: function (e) {
            if (e.key == 'Control') {
                this.ctrlIsPressed = true;
            }
        },

        unpressCtrl: function () {
            this.ctrlIsPressed = false;
        },

        changeScale: function (e) {
            if (this.ctrlIsPressed) {
                e.preventDefault();
                if (e.deltaY < 0) {
                    if (this.tlScale < 5) {
                        this.tlScale = this.tlScale + 1;
                    }
                } else {
                    if (this.tlScale > 1) {
                        this.tlScale = this.tlScale - 1;
                    }
                }
            }
        },

        nextMedia: function () {
            if (this.play) {
                this.stopPLayback();
            }
            this.mediaIndex++;
            this.currentLength = this.medialist.slice(0, this.mediaIndex).reduce((sum, item) => sum + item.length, 0);
            document.querySelector('.pl-scale-scroll').style.left = `${this.currentLength * 10}px`;
            this.currentTime = this.secondsToHms(this.currentLength, 'b');
        },

        changeMediaByClick: function (index) {
            if (this.play) {
                this.stopPLayback();
            }
            this.mediaIndex = index;

            this.currentLength = this.medialist.slice(0, index).reduce((sum, item) => sum + item.length, 0);
            document.querySelector('.pl-scale-scroll').style.left = `${this.currentLength * 10}px`;
            this.currentTime = this.secondsToHms(this.currentLength, 'b');
        },

        stopPLayback() {
            this.play = false;
            // Очищаем таймер прошеджшего времени воспроизведения элемента
            clearInterval(this.picPlayIntervalId);

            // Очищаем таймер заданного времени воспроизведения элемента
            clearInterval(this.picPlayTimoutId);
            this.picCurrentTime = 0;
        },

        secondsToHms: function (d, format) {
            d = Number(d);
            let h = Math.floor(d / 3600);
            let m = Math.floor(d % 3600 / 60);
            let s = Math.floor(d % 3600 % 60);
            let hDisplay = '';
            let mDisplay = '';
            let sDisplay = '';
            switch (format) {
                case 'a':
                    hDisplay = h > 0 ? h + 'ч, ' : "";
                    mDisplay = m > 0 ? m + ' мин, ' : "";
                    sDisplay = s > 0 ? s + ' сек' : "";
                    break;
                case 'b':
                    if (h > 0 && h < 10) {
                        hDisplay = `0${h}:`;
                    } else if (h > 0) {
                        hDisplay = `${h}:`;
                    } else {
                        hDisplay = '';
                    }
                    if (m > 0 && m < 10) {
                        mDisplay = `0${m}:`;
                    } else if (h > 0) {
                        mDisplay = `${m}:`;
                    } else {
                        mDisplay = '00:';
                    }
                    if (s > 0 && s < 10) {
                        sDisplay = `0${s}`;
                    } else if (s > 0) {
                        sDisplay = `${s}`;
                    } else {
                        sDisplay = '00';
                    }
                    break;
            }
            return hDisplay + mDisplay + sDisplay;
        },

        dropItem: function (event) {
            if (this.selectedItems.length == 0) {
                let arrayDuration = this.dragged_item.duration.split(":");
                let duration = (parseInt(arrayDuration[0], 10) * 60 * 60) + (parseInt(arrayDuration[1], 10) * 60) + parseInt(arrayDuration[2], 10);
                this.medialist.push({
                    id: this.dragged_item.id,
                    source: this.dragged_item.path,
                    length: duration,
                    thumb: (this.dragged_item.type_id === 1) ? this.dragged_item.path : this.dragged_item.frame_path,
                    poster: (this.dragged_item.type_id === 1) ? this.dragged_item.path : this.dragged_item.frame_path,
                    width: 10,
                    name: this.dragged_item.name
                });
            }
            else {
                for (let elements of this.selectedItems) {
                    let arrayDuration = elements.duration.split(":");
                    let duration = (parseInt(arrayDuration[0], 10) * 60 * 60) + (parseInt(arrayDuration[1], 10) * 60) + parseInt(arrayDuration[2], 10);
                    this.medialist.push({
                        id: elements.id,
                        source: elements.path,
                        length: duration,
                        thumb: (elements.type_id === 1) ? elements.path : elements.frame_path,
                        poster: (elements.type_id === 1) ? elements.path : elements.frame_path,
                        width: 10,
                        name: elements.name
                });
                }
            }
            this.selectedItems.forEach((item) => {
                item.selected = false;
            })
            this.selectedItems = [];
            this.dragged_item = {};
            for (let element of document.querySelectorAll('.content-element__checkbox')) {
                element.checked = false
            }
            this.setPointAndThumbsWidth();
        },

        dragItem: function (item) {
            this.dragged_item = item;
        },

        startSwapItem: function (item, index) {
            this.swap_item_index = index;
        },

        endSwapItem: function (item, index) {
            if (this.swap_item_index === false) {
                this.dropItem();
                return;
            }
            if (this.swap_item_index === index) {
                return;
            }
            let swapItem = this.medialist[this.swap_item_index];
            this.medialist.splice(this.swap_item_index, 1);
            this.medialist.splice(index, 0, swapItem);
            this.swap_item_index = false;
        },

        endSwapItemLast: function () {
            if (this.swap_item_index === false) {
                this.dropItem();
                return;
            }
            let lastIndex = this.medialist.length - 1;
            if (this.swap_item_index === this.medialist.length - 1) {
                return;
            }
            let swapItem = this.medialist[this.swap_item_index];
            this.medialist.splice(this.swap_item_index, 1);
            this.medialist.splice(lastIndex, 0, swapItem);
            this.swap_item_index = false;
        },

        selectItem(item) {
            const index = this.selectedItems.indexOf(item)
            if (index === -1) {
                this.selectedItems.push(item)
            } else {
                this.selectedItems.splice(index, 1)
            }
        },

        isSelected(item) {
            return this.selectedItems.indexOf(item) !== -1
        },
    },

    watch: {
        // ОТЛАДКА
        // mediaIndex: {
        //     handler() {
        //         console.log('this.mediaIndex', this.mediaIndex);
        //     }
        // },

        // currentLength: {
        //     handler() {
        //         console.log('this.currentLength', this.currentLength);
        //     }
        // },

        // remains: {
        //     handler() {
        //         console.log('this.remains в милисекундах', this.remains);
        //     }
        // },

        // elementStart: {
        //     handler() {
        //         console.log('this.elementStart', this.elementStart);
        //     }
        // },

        // elementNext: {
        //     handler() {
        //         console.log('this.elementNext', this.elementNext);
        //     }
        // },

        // elementPrev: {
        //     handler() {
        //         console.log('this.elementPrev', this.elementPrev);
        //     }
        // },

        // picCurrentTime: {
        //     handler() {
        //         console.log('this.picCurrentTime', this.picCurrentTime);
        //     }
        // },

        // time: {
        //     handler() {
        //         console.log('this.time', this.time);
        //     }
        // },
        // ОТЛАДКА

        medialist: {
            handler() {
                this.$emit('syncContent', this.medialist);
            },
            deep: true
        },

        playlist_content: {
            handler() {
                this.medialist = this.playlist_content;
                this.elementNext = this.medialist[0].length;
                this.setPointAndThumbsWidth();
            },
            deep: true
        },

        tlScale: function () {
            this.setPointAndThumbsWidth();
            this.$nextTick(() => {
                this.renderTlPoints();
            });
        },

        itemsFromFolder: {
            handler(newItems) {
                this.hasFiles = newItems.some(obj => obj.type !== 2);
            },
        }
    },

    computed: {
        mediaSrc() {
            if (this.medialist && this.medialist.length) {
                if (this.mediaIndex > this.medialist.length - 1) {
                    this.mediaIndex--;
                }

                return this.src(this.medialist[this.mediaIndex].source);
            } else {
                return '';
            }

        },

        mediaPoster() {
            if (this.medialist && this.medialist.length) {
                if (this.mediaIndex > this.medialist.length - 1) {
                    this.mediaIndex--;
                }
                return this.src(this.medialist[this.mediaIndex].poster);
            } else {
                return '';
            }
        },

        mediaFullLength() {
            return this.secondsToHms(this.medialist.reduce((sum, item) => sum + item.length, 0), 'b');
        }
    },

    mounted() {
        this.preview = this.$refs.preview;
        this.media = this.$refs.media;
        this.media.volume = this.volume;
        this.filename = this.$refs.filename;

        this.fileTl = this.$refs.fileTl;
        
        // Контейнер таймлайна
        this.tlWrap = this.$refs.tlWrap;

        // Значение селекта над шкалой времени
        this.tlScaleEl = this.$refs.tlScale;

        if (document.addEventListener) {
            document.addEventListener('fullscreenchange', this.exitHandler, false);
            document.addEventListener('mozfullscreenchange', this.exitHandler, false);
            document.addEventListener('MSFullscreenChange', this.exitHandler, false);
            document.addEventListener('webkitfullscreenchange', this.exitHandler, false);
        }

        window.addEventListener('load', this.setPointAndThumbsWidth);
        window.addEventListener('load', this.renderTlPoints);
        document.body.addEventListener('resize', this.setPointAndThumbsWidth);

        window.addEventListener('keydown', this.pressCtrl);
        window.addEventListener('keyup', this.unpressCtrl);
    },
};
</script>

<style scoped></style>